import styles from './dashboard.module.scss';

import React from 'react';
import { Container } from 'reactstrap';

import ButtonLink from 'src/components/ButtonLink';
import RetinaImage from 'src/components/RetinaImage';
import { ScrollOverPack, TweenOne, FadeLeft } from 'src/components/Animations';
import DashboardReportingAuditingSplash from 'src/components/DashboardReportingAuditingSplash';
import FeaturesLinksSection from 'src/components/FeaturesLinksSection';
import TestimonialsSection from 'src/components/TestimonialsSection';
import CarriersGridSection from 'src/components/CarriersGridSection';

import ImgShippingContainers from 'src/images/img-shipping-containers.jpg';
import ImgShippingContainers2x from 'src/images/img-shipping-containers@2x.jpg';
import ImgShippingContainers3x from 'src/images/img-shipping-containers@3x.jpg';
import IconCarrierAgnostic from 'src/images/icon-carrier-agnostic.png';
import IconCarrierAgnostic2x from 'src/images/icon-carrier-agnostic@2x.png';
import IconCarrierAgnostic3x from 'src/images/icon-carrier-agnostic@3x.png';

const Hero = (props) => (
  <div styleName='hero'>
      <Container>
          <div styleName='text-container'>
              <RetinaImage srcSet={[IconCarrierAgnostic, IconCarrierAgnostic2x, IconCarrierAgnostic3x]} />
              <div className='h1 mt-2'>Carrier agnostic</div>
              <div className='h2 text-blue'>If you ship it, we support it.</div>
              <div styleName='message'>
                  The world doesn’t stop with UPS and FedEx. More and more
                  shippers rely on USPS, DHL, and regional carriers. That’s why
                  we support more carrier integrations than anyone else in the
                  industry. Don’t see your carrier listed? Custom integrations
                  are available for enterprise clients.
              </div>
              <ButtonLink styleName='button' to='/contact'>
                  Try free for 7 days
              </ButtonLink>
          </div>
      </Container>
      <ScrollOverPack styleName='splash-image-container'>
          <TweenOne key='0'
                    component={RetinaImage}
                    srcSet={[ImgShippingContainers, ImgShippingContainers2x, ImgShippingContainers3x]}
                    styleName='splash-image'
                    {...FadeLeft} />
      </ScrollOverPack>
  </div>
);

export default (props) => (
  <div>
      <Hero />
      <CarriersGridSection />
      <DashboardReportingAuditingSplash />
      <TestimonialsSection />
      <FeaturesLinksSection />
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/features/carrier-agnostic.js